import { useContext } from "react";
import userContext from "./context.js";
import { Card } from "react-bootstrap";


export default function Alldata() {
  let user = useContext(userContext);
  console.log("hi", user.users);
  return (
    <div id="alldata">
      <Card id="form-card">
      <h1>Alldata</h1><br />
      {user.users.map((item, key) => (
        <b>
         Name: {item.Name} (Balance:{item.balance})
          </b>
        
      ))}
      </Card>
    </div>
  );
}

